import React from 'react'
import { useSuperscript } from './SuperscriptHelper'

const MarkdownHelper = {

    defaultConfig: {
        unwrapDisallowed: true,
        renderers: {root: React.Fragment}
    },

    basicTypes: () => ({
        ...MarkdownHelper.defaultConfig,
        allowedTypes: ['heading', 'list', 'listItem', 'image', 'link', 'text', 'html', 'strong'],
        renderers: {
            root: React.Fragment,
            text: MarkdownHelper.customRenderer.textWithSuperscript,
        }
    }),

    headingTypes: () => ({
        ...MarkdownHelper.defaultConfig,
        allowedTypes: ['break', 'strong', 'emphasis', 'text', 'html'],
        renderers: {
            root: React.Fragment,
            text: MarkdownHelper.customRenderer.textWithSuperscript,
        }
    }),

    allTypes: () => ({
        ...MarkdownHelper.defaultConfig,
        escapeHtml: false,
        allowedTypes: ['break', 'strong', 'emphasis', 'heading', 'list', 'listItem', 'image', 'link', 'text', 'html'],
        renderers: {
            root: React.Fragment,
            text: MarkdownHelper.customRenderer.textWithSuperscript,
        }
    }),

    allTypesWithoutSuperscript: () => ({
        ...MarkdownHelper.defaultConfig,
        escapeHtml: false,
        allowedTypes: ['break', 'strong', 'emphasis', 'heading', 'list', 'listItem', 'image', 'link', 'text', 'html'],
        renderers: {
            root: React.Fragment,
            text: MarkdownHelper.customRenderer.textWithoutSuperscript,
        }
    }),

    termsAndConditionsTypes: () => ({
      ...MarkdownHelper.defaultConfig,
      escapeHtml: false,
      allowedTypes: ['break', 'strong', 'emphasis', 'heading', 'list', 'listItem', 'image', 'link', 'html']
    }),

    listTypes: () => ({
        ...MarkdownHelper.defaultConfig,
        allowedTypes: ['break', 'strong', 'emphasis', 'link', 'text', 'html']
    }),

    keyfactsTypes: () => ({
        ...MarkdownHelper.defaultConfig,
        allowedTypes: ['break', 'strong', 'emphasis', 'html', 'heading', 'list', 'listItem', 'image', 'link', 'text'],
        renderers: {
            root: React.Fragment,
            listItem: MarkdownHelper.customRenderer.listItem,
            text: MarkdownHelper.customRenderer.textWithSuperscript
        },
    }),

    customRenderer: {
        textWithSuperscript: (props) => useSuperscript(props.value),
        textWithoutSuperscript: (props) => useSuperscript(props.value, true),
        listItem: (props) => {
            const coreProps = props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {}

            return (
                <li {...coreProps}>
                    <div>
                        {props.children}
                    </div>
                </li>
            )
        },
    },

    parse: input => {
        if (!input || input === null) {
            return input
        }

        return input
            .toString()
            .replace(/(?!^)\*/g, '\n*')
            .replace(/\|\n\*/g, '\n  *')
            .replace(/##/g, '\n  ##')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/%%/g, '\n')
    }
}

export default MarkdownHelper



// WEBPACK FOOTER //
// ./src/components/utils/MarkdownHelper.js